{
  " - Charges": " - Charges",
  " - Produits": " - Produits",
  "__all__": "Unexpected error",
  "Account": "Account",
  "Account disabled": "Account disabled",
  "Accounting firm": "Accounting firm",
  "Accounting Firm": "Accounting Firm",
  "Accounting firm not found": "Accounting firm not found",
  "Achats et fournitures": "Achats et fournitures",
  "Action": "Action",
  "Actions": "Actions",
  "Active": "Active",
  "Add": "Add",
  "Add cycle": "Add cycle",
  "Add keyword": "Add keyword",
  "Add Vat": "Add Vat",
  "Add ventilation": "Add ventilation",
  "All": "All",
  "Amount": "Amount",
  "Amount range": "Amount range",
  "Amount to be distributed": "Amount to be distributed",
  "Amout": "Amout",
  "An error occurred, please refresh the page or click the button below": "An error occurred, please refresh the page or click the button below",
  "An unexpected error occurred processing your request, please try again later": "An unexpected error occurred processing your request, please try again later.",
  "Annotations": "Annotations",
  "Are you sure you want to delete this bulk?": "Are you sure you want to delete this bulk?",
  "Are you sure you want to delete this delivery?": "Are you sure you want to delete this delivery?",
  "Are you sure you want to delete this transaction?": "Are you sure you want to delete this transaction?",
  "Are you sure you want to move the bulk to Neoscan Expert?": "Are you sure you want to move the bulk to Neoscan Expert?",
  "Are you sure you want to move the bulk to SSI?": "Are you sure you want to move the bulk to SSI?",
  "Assign a category": "Assign a category",
  "Assign saved with success": "Assign saved with success.",
  "ATC": "ATC",
  "Auto Liquidation": "Auto Liquidation",
  "Back to list": "Back to list",
  "Bank": "Bank",
  "Bank account": "Bank account",
  "Bank accounts": "Bank accounts",
  "Bank description": "Bank description",
  "Banks": "Banks",
  "Banks account": "Banks account",
  "Banks accounts": "Banks accounts",
  "Banks connections": "Banks connections",
  "Book": "Book",
  "Book Bank": "Book Bank",
  "Book cashed checks (Income)": "Book cashed checks (Income)",
  "Book issued checks (Expense)": "Book issued checks (Expense)",
  "Bulk deleted with success": "Bulk deleted with success.",
  "Bulks not validated": "Bulks not validated",
  "Bulks validated": "Bulks validated",
  "Cancel": "Cancel",
  "Categories": "Categories",
  "Categories and Amount": "Categories and Amount",
  "categoriesAuto": "{{count}} Category were automaticly parametrized",
  "categoriesAuto_one": "{{count}} Categories were automaticly parametrized",
  "categoriesAuto_other": "{{count}} Categories were automaticly parametrized",
  "categoriesAuto_plural": "{{count}} catégories ont été paramétrées automatiquement",
  "Categorized": "Categorized",
  "Category": "Category",
  "Change": "Change",
  "Change Bulk": "Change Bulk",
  "Change Delivery": "Change Delivery",
  "Charges": "Charges",
  "Charges de personnel": "Charges de personnel",
  "Charges Externes": "Charges Externes",
  "Click or drag file to this area to upload": "Click or drag file to this area to upload",
  "Click or drag file to this area to upload!": "Click or drag file to this area to upload!",
  "Client support": "Client support",
  "Close": "Close",
  "Code": "Code",
  "Code VAT": "Code VAT",
  "Collection sheet": "Collection sheet",
  "Company": "Company",
  "Company not found": "Company not found",
  "Compte": "Compte",
  "Compte de Bilan ": "Compte de Bilan ",
  "Compte de Charge/Produit": "Compte de Charge/Produit",
  "Compte de resultat": "Compte de resultat",
  "Confirm": "Confirm",
  "Confirm that you want to deactivate the connection?": "Confirm that you want to deactivate the connection?",
  "Confirm the transactions to be submitted": "Confirm the transactions to be submitted",
  "Connect to bank": "Connect to bank",
  "Connection": "Connection",
  "Connection bank": "Connection bank",
  "Connection Errors": "Connection Errors",
  "Connector Bank": "Connector Bank",
  "Counterpart": "Counterpart",
  "Counterpart Bank": "Counterpart Bank",
  "Counterpart Buy": "Counterpart Buy",
  "Counterpart cashed checks (Income)": "Counterpart cashed checks (Income)",
  "Counterpart Immobilization": "Counterpart Immobilization",
  "Counterpart issued checks (Expense)": "Counterpart issued checks (Expense)",
  "Counterpart Sell": "Counterpart Sell",
  "Couterparts by cycle": "Couterparts by cycle",
  "Create": "Create",
  "Create bank cycle": "Create bank cycle",
  "Credit": "Credit",
  "Currency": "Currency",
  "Custom": "Custom",
  "Cycle": "Cycle",
  "Cycle date is not configured": "Cycle date is not configured",
  "Cycle date is not valid": "Cycle date is not valid",
  "Cycle settings": "Cycle settings",
  "Cycles": "Cycles",
  "Cycles to sync": "Cycles to sync",
  "Date": "Date",
  "Date range": "Date range",
  "Date/Time": "Date/Time",
  "Debit": "Debit",
  "Debit / Credit": "Debit / Credit",
  "Default book": "Default book",
  "Default counterpart": "Default counterpart",
  "Default Vat": "Default Vat",
  "Default Vat Counterpart": "Default Vat Counterpart",
  "Delete": "Delete",
  "Delete Bulk": "Delete Bulk",
  "Deliveries not validated": "Deliveries not validated",
  "Deliveries validated": "Deliveries validated",
  "Delivery deleted with success": "Delivery deleted with success.",
  "Desactive": "Desactive",
  "Description": "Description",
  "Disable bank account": "Disable bank account",
  "Disconnect": "Disconnect",
  "Divers": "Divers",
  "Do you want to delete these document?": "Do you want to delete these document?",
  "Do you Want to delete these document?": "Do you Want to delete these document?",
  "Do you want to delete this document?": "Do you want to delete this document?",
  "Document": "Document",
  "Documents": "Documents",
  "Dont TVA": "Dont TVA",
  "Drop a File": "Drop a File",
  "Edit": "Edit",
  "Edit bank": "Edit bank",
  "Edit bank account": "Edit bank account",
  "Edit bank cycle": "Edit bank cycle",
  "Edit Category": "Edit Category",
  "Edit cycle settings": "Edit cycle settings",
  "Edit settings": "Edit settings",
  "Edit vat": "Edit vat",
  "End": "End",
  "End connection with powens": "End connection with powens",
  "End date": "End date",
  "English": "English",
  "Error": "Error",
  "Existing keywords": "Existing keywords",
  "Expense": "Expense",
  "Expense Cash": "Expense Cash",
  "Expense Cash ": "Expense Cash ",
  "Expense Claim": "Expense Claim",
  "Expense Claim ": "Expense Claim ",
  "Expense Claim Counterpart": "Expense Claim Counterpart",
  "Expense In Cash Counterpart": "Expense In Cash Counterpart",
  "Fiche": "Fiche",
  "Filters": "Filters",
  "French": "French",
  "Go to Account": "Go to Account",
  "Go to dashboard": "Go to dashboard",
  "Go to Home": "Go to Home",
  "Go to settings": "Go to settings",
  "Group": "Group",
  "HelpDesk": "HelpDesk",
  "Iban": "Iban",
  "Id": "Id",
  "Image must be smaller than 2MB!": "Image must be smaller than 2MB!",
  "Impots": "Impots",
  "Inactive": "Inactive",
  "Income BankAccount": "Income BankAccount",
  "Income BankAccount ": "Income BankAccount ",
  "Income Cash": "Income Cash",
  "Income Cash ": "Income Cash ",
  "Income In Cash Counterpart": "Income In Cash Counterpart",
  "Income In Personal Bank Account Counterpart": "Income In Personal Bank Account Counterpart",
  "Info": "Info",
  "Invoice No.": "Invoice No.",
  "Is connected": "Is connected",
  "Is imobilization": "Is imobilization",
  "It is necessary to configure the bank accounts with the accounting data for the date of this transaction. After this configuration you will be able to classify your transactions.": "It is necessary to configure the bank accounts with the accounting data for the date of this transaction. After this configuration you will be able to classify your transactions.",
  "It is not possible to send more than 1 document!": "It is not possible to send more than 1 document!",
  "It is not possible to send more than 8 documents!": "It is not possible to send more than 8 documents!",
  "Keyword": "Keyword",
  "Keywords": "Keywords",
  "Label": "Label",
  "Last month": "Last month",
  "Last semester": "Last semester",
  "Last Transactions Sync": "Last Transactions Sync",
  "Last update": "Last update",
  "Last Update": "Last Update",
  "Last week": "Last week",
  "Last year": "Last year",
  "List transaction": "List transaction",
  "Load more": "Load more",
  "Loading": "Loading...",
  "Loading...": "Loading...",
  "Login": "Login",
  "Logout": "Logout",
  "Main Bank": "Main Bank",
  "Manage in Powens": "Manage in Powens",
  "Manage powens connections": "Manage powens connections",
  "Max": "Max",
  "Min": "Min",
  "Missing amount": "Missing amount",
  "Missing category": "Missing category",
  "Missing Dont TVA": "Missing Dont TVA",
  "Missing TVA": "Missing TVA",
  "Montant TTC": "Montant TTC",
  "Name": "Name",
  "New": "New",
  "Newrai support": "Newrai support",
  "No": "No",
  "No Access": "No Access",
  "No active cycle is configured for this bank account. A new cycle must be created.": "No active cycle is configured for this bank account. A new cycle must be created.",
  "No keywords yet": "No keywords yet",
  "No options": "No options",
  "No Options": "No Options",
  "No transactions": "No transactions",
  "Non active": "Non active",
  "Not Started": "Not Started",
  "Not validated": "Not validated",
  "on": "on",
  "Oops Page Not Found": "Oops Page Not Found",
  "Operating result": "Operating result",
  "Operation type": "Operation type",
  "Operation Type": "Operation Type",
  "Operations": "Operations",
  "OPS": "OPS",
  "Order by": "Order by",
  "Page Not Found": "Page Not Found",
  "Par catégorie": "Par catégorie",
  "Par compte": "Par compte",
  "Par type d'opération": "Par type d'opération",
  "Period": "Period",
  "Pilotage": "Pilotage",
  "Please contact support.": "Please contact support.",
  "Please input Counterpart Immobilization": "Please input Counterpart Immobilization",
  "Please select a company to view company data": "Please select a company to view company data.",
  "Please select the words you want to assign to a category in the box below.": "Please select the words you want to assign to a category in the box below.",
  "Preview": "Preview",
  "previous month": "previous month",
  "Previous semester": "Previous semester",
  "Produits": "Produits",
  "Purchase allocation": "Purchase allocation",
  "Rate": "Rate",
  "Recipes": "Recipes",
  "Reconciliation": "Reconciliation",
  "Reconnect": "Reconnect",
  "Reference": "Reference",
  "Refresh page": "Refresh page",
  "Refresh transactions": "Refresh transactions",
  "Regime": "Regime",
  "Registered": "Registered",
  "Required action": "Required action",
  "Reset": "Reset",
  "Reset filters": "Reset filters",
  "Retransfer of a bulk to SSI": "Retransfer of a bulk to SSI",
  "Roll Back made with success": "Roll Back made with success.",
  "Sales allocation": "Sales allocation",
  "Save": "Save",
  "Save success": "Save success",
  "Save Success": "Save Success",
  "Saved": "Saved",
  "Saved Successfully": "Saved Successfully",
  "Search": "Search",
  "Search or create a keyword": "Search or create a keyword",
  "Section": "Section",
  "Select": "Select",
  "Select all categorized transactions": "Select all categorized transactions",
  "Select book": "Select book",
  "Select book bank": "Select book bank",
  "Select Category": "Select Category",
  "Select company": "Select company",
  "Select Company": "Select Company",
  "Select connector bank": "Select connector bank",
  "Select counterpart": "Select counterpart",
  "Select counterpart bank": "Select counterpart bank",
  "Select cycle": "Select cycle",
  "Select Text": "Select Text",
  "Selected_one": "{count} Selected",
  "Selected_other": "{count} Selected",
  "Selected Words": "Selected Words",
  "Send back to neoscan expert": "Send back to neoscan expert",
  "Send back to SSI": "Send back to SSI",
  "SEPA Credential Identifier": "SEPA Credential Identifier",
  "Setting up bank accounts": "Setting up bank accounts",
  "Settings": "Settings",
  "Some banks will be removed because they are duplicates": "Some bank accounts will be removed because they are duplicates",
  "Sorry, you are not authorized to access this page. Please contact your company's accountant": "Sorry, you are not authorized to access this page. Please contact your company's accountant",
  "SSI type": "SSI type",
  "SSI Type": "SSI Type",
  "Start": "Start",
  "Start date": "Start date",
  "status": "status",
  "Status": "Status",
  "Submit": "Submit",
  "Submit here the supporting documents that you wish to attach to this transaction": "Submit here the supporting documents that you wish to attach to this transaction",
  "Submited by": "Submited by",
  "Submitted": "Submitted",
  "submitTransactions": "submitTransactions",
  "submitTransactions_plural": "submitTransactions",
  "Suggestion": "Suggestion",
  "Sync": "Sync",
  "Sync Accounts": "Sync Accounts",
  "Sync Connections": "Sync Connections",
  "Sync Transactions": "Sync Transactions",
  "Terminate connection": "Terminate connection",
  "Thank you": "Thank you",
  "The connection is not synchronized": "The connection is not synchronized",
  "The counterpart has been successfully added to the category": "The counterpart has been successfully added to the category",
  "The counterpart related to the transaction type is not setting up correctly": "The counterpart related to the transaction type is not setting up correctly",
  "The current cycle": "The current cycle",
  "The document could not be linked to the transaction": "The document could not be linked to the transaction",
  "The document has been successfully linked to the transaction": "The document has been successfully linked to the transaction",
  "The inserted date is not valid or the cycle doesn't exist": "The inserted date is not valid or the cycle doesn't exist",
  "The keyword has been successfully added to the category": "The keyword has been successfully added to the category",
  "The page you are looking for does not exist or has been moved": "The page you are looking for does not exist or has been moved.",
  "The transaction has been successfully deleted": "The transaction has been successfully deleted",
  "There are no transactions": "There are no transactions",
  "There are no transactions categorized to be validated": "There are no transactions categorized to be validated",
  "There are transactions outside the activity cycle.": "There are transactions outside the activity cycle.",
  "There is no connection": "There is no connection",
  "These transactions cannot be classified, this information this in the corresponding transactions.": "These transactions cannot be classified, this information this in the corresponding transactions.",
  "Third party": "Third party",
  "This accounting firm does not exist or you do not have access to it.": "This accounting firm does not exist or you do not have access to it.",
  "This action will disable the bank account and all associated transactions. Are you sure you want to disable this bank account?": "This action will disable the bank account and all associated transactions. Are you sure you want to disable this bank account?",
  "This category is not parameterized, go to the categories menu and configure it.": "This category is not parameterized, go to the categories menu and configure it.",
  "This company does not exist or you do not have access to it.": "This company does not exist or you do not have access to it.",
  "This field is required": "This field is required",
  "This transaction cannot be classified because it is not associated with a banking exercise.": "This transaction cannot be classified because it is not associated with a banking exercise.",
  "This transaction cannot be classified because it is not associated with a fiscal year or a banking year.": "This transaction cannot be classified because it is not associated with a fiscal year or a banking year.",
  "This word is already a keyword for category {{category}}": "This word is already a keyword for category {{category}}",
  "to": "to",
  "To categorize": "To categorize",
  "To define": "To define",
  "Total": "Total",
  "Total Balance": "Total Balance",
  "Total pages": "Total pages",
  "Total table items_one": "Total table items",
  "Total table items_other": "Total table items",
  "Transaction": "Transaction",
  "Transactions": "Transactions",
  "Transactions exceed the current cycle. A new cycle is required.": "Transactions exceed the current cycle. A new cycle is required.",
  "Transactions imported successfully": "Transactions imported successfully",
  "Transactions were successfully submitteds": "Transactions have been successfully submitted",
  "Transactios": "Transactios",
  "Transations": "Transations",
  "TVA": "TVA",
  "Types of transactions": "Types of transactions",
  "Unexpected error": "Unexpected error",
  "unsuccess": "The amount has not been fully distributed, {{amount}} remains to be allocated.",
  "Updated": "Updated",
  "Validate transactions": "Validate transactions",
  "Validate transactions ": "Validate transactions ",
  "Validate transactions_plural": "Validate transactions",
  "Validated": "Validated",
  "Value is not valid": "Value is not valid",
  "Vat": "Vat",
  "Vat NewRAi": "Vat NewRAi",
  "Vat Saved with Success": "Vat Saved with Success",
  "VAT to be defined": "VAT to be defined",
  "Vats": "Vats",
  "Ventilation": "Ventilation",
  "Ventilations": "Ventilations",
  "We found these documents from the selected date. Would you like to link one of them to this transaction?": "We found these documents from the selected date. Would you like to link one of them to this transaction?",
  "With": "With",
  "Without": "Without",
  "Yes": "Yes",
  "You are logged out": "You are logged out",
  "You can only upload JPG/PNG/PDF file!": "You can only upload JPG/PNG/PDF file!",
  "You must fill in at least one Ventilation": "You must fill in at least one Ventilation"
}
